<template>
    <div class="loginPage">
        <div class="background_box" :class="bgClass"></div>
        <div class="loginBox">
            <h1>智码通智慧营销平台</h1>
            <el-form
                :model="formData"
                status-icon
                :rules="rules"
                ref="ruleForm"
                label-width="70px"
                class="loginForm"
            >
                <el-form-item class="formLabel" label="账号：" prop="userName">
                    <el-input v-model="formData.userName" placeholder="请输入账号"></el-input>
                </el-form-item>
                <el-form-item class="formLabel" label="密码：" prop="password">
                    <el-input type="password" v-model="formData.password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-button
                    type="primary"
                    :loading="btnLoading"
                    class="loginBtn"
                    @click="submitForm('ruleForm')"
                >登录</el-button>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
  data: function() {
    var validateUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else if (value.length < 1) {
        callback(new Error("请输入正确账号！"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 4) {
        callback(new Error("密码不可以少4位"));
      } else {
        callback();
      }
    };
    return {
      bgTimer: null,
      time: 1,
      bgClass: "current1",
      formData: {
        userName: "",
        password: ""
      },
      btnLoading: false,
      rules: {
        userName: [{ validator: validateUsername, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }]
      }
    };
  },
  beforeCreate: function() {
    document.title = "智码通智慧营销平台";
  },
  destroyed() {
    clearInterval(this.bgTimer);
    this.$destroy(true);
  },
  mounted: function() {
    this.$nextTick(() => {
      this.bgTimer = setInterval(this.timer, 3000);
    });
  },
  methods: {
    // 定时器开启更换背景图片
    timer() {
      if (this.time >= 4) {
        this.time = 0;
      } else {
        this.time++;
        this.bgClass = "current" + this.time;
      }
    },
    submitForm(formName) {
      let self = this;
      self.btnLoading = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          $http.POST({
            url:
              this.$store.state.apiUrl +
              "/api/services/app/AdminUser/AdminLogin",
            data: this.formData,
            success(res) {
              if (res.token) {
                localStorage.setItem("accessToken", res.token);
                localStorage.setItem("yth_userName", self.formData.userName);
                localStorage.setItem("yth_divisionID", res.divisionID);
                self.$router.push({
                  path: "/home"
                });
              }
              self.btnLoading = false;
            },
            fail(res) {
              self.btnLoading = false;
            }
          });
        } else {
          self.btnLoading = false;
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.loginPage {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
}
.background_box {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  transform: scale(1.1, 1.1);
  transition: all 0.6s ease-in 0.6s;
  background-image: url("./../../assets/imgs/mohu1.jpg");
  background-size: cover;
  &.current1 {
    background-image: url("./../../assets/imgs/mohu1.jpg");
  }
  &.current2 {
    background-image: url("./../../assets/imgs/mohu2.jpg");
  }
  &.current3 {
    background-image: url("./../../assets/imgs/mohu3.jpg");
  }
  &.current4 {
    background-image: url("./../../assets/imgs/mohu4.jpg");
  }
}
.loginBox {
  position: relative;
  z-index: 1;
  margin-top: 200px;
  width: 400px;
  height: 350px;
  background: #fff;
  border-radius: 10px;
  font-size: 22px;
  h1 {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loginForm {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 220px;
    justify-content: space-around;
    .formLabel {
      padding-right: 50px;
    }
    .loginBtn {
      margin: 0 !important;
    }
  }
}
</style>
